import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../utils/handleError';
import i18next from 'i18next';
import _ from 'lodash';
import Dict from '../../utils/Dict';
import Notice from '../../utils/Notice';
import { NCALayerSign } from '../../components/NCALayer/NCALayerSign';
import { TalonRegistrationApi } from './TalonRegistrationApi';

/**
 * Constants
 */

export const talonRegistrationModule = 'talonRegistration';

const LOADING_TABLE = `${talonRegistrationModule}/LOADING_TABLE`;
const TABLE_DATA = `${talonRegistrationModule}/TABLE_DATA`;
const LOADING_DETAIL = `${talonRegistrationModule}/LOADING_DETAIL`;
const DETAIL_DATA = `${talonRegistrationModule}/DETAIL_DATA`;
const REGISTERING = `${talonRegistrationModule}/REGISTERING`;
const CLEAR_STATE = `${talonRegistrationModule}/CLEAR_STATE`;

/**
 * Reducer
 */

const initialState = {
  loadingTable: false,
  registeringId: null,
  loadingDetail: false,
  detail: {},
  tableData: {
    content: [],
    totalElements: 0
  }
};

export default createReducer(initialState, {
  [LOADING_TABLE]: (state, action) => {
    state.loadingTable = action.payload;
  },
  [LOADING_DETAIL]: (state, action) => {
    state.loadingDetail = action.payload;
  },
  [DETAIL_DATA]: (state, action) => {
    state.detail = action.payload;
  },
  [REGISTERING]: (state, action) => {
    state.registeringId = action.payload;
  },
  [TABLE_DATA]: (state, action) => {
    const filter = action.filter || {};
    if (filter.pageNumber && filter.pageNumber !== 1) {
      state.tableData.content = [...state.tableData.content, ...action.payload.content];
    } else {
      state.tableData = action.payload;
    }
  },
  [CLEAR_STATE]: () => initialState
});

/**
 * Actions
 */

export const clearState = () => ({ type: CLEAR_STATE });

export const loadTableData = filter => async dispatch => {
  try {
    dispatch({ type: LOADING_TABLE, payload: true });
    // В фильтр отправляем пагинацию и только активные талоны
    const requestFilter = {
      pageNumber: filter.pageNumber,
      pageSize: filter.pageSize,
      isActive: true
    };
    let { data } = await TalonRegistrationApi.loadTableData(JSON.stringify(requestFilter));
    if (data.status === 'SUCCESS') {
      const dictKato = await Dict.itemsObject('60');
      for (let row of data.result.content) {
        row.serviceProviderLegalLocalityName =
          dictKato[row.serviceProviderLegalLocality] || {};
      }
      dispatch({ type: TABLE_DATA, payload: data.result, filter });
    } else {
      handleError(data, i18next.t('talonRegistration_errorLoadTable'));
    }
  } catch (error) {
    handleError(error, i18next.t('talonRegistration_errorLoadTable'));
  } finally {
    dispatch({ type: LOADING_TABLE, payload: false });
  }
};

export const loadDetail = id => async dispatch => {
  try {
    dispatch({ type: LOADING_DETAIL, payload: true });
    let { data } = await TalonRegistrationApi.loadById(id);
    if (data.status === 'SUCCESS') {
      const detail = data.result;
      const dictKato = await Dict.itemsObject('60');
      detail.serviceProviderLegalLocalityName =
        dictKato[detail.serviceProviderLegalLocality] || {};
      dispatch({ type: DETAIL_DATA, payload: detail });
    } else {
      handleError(data, i18next.t('talonRegistration_errorLoadDetail'));
    }
  } catch (error) {
    handleError(error, i18next.t('talonRegistration_errorLoadDetail'));
  } finally {
    dispatch({ type: LOADING_DETAIL, payload: false });
  }
};

// Подписание и регистрация уведомления как талона
export const registerCoupon = (notifyId, reload) => async dispatch => {
  try {
    dispatch({ type: REGISTERING, payload: notifyId });
    // 1. Получаем строку для подписи
    const { data: sign } = await TalonRegistrationApi.getSignString({ notifyId });
    // 2. Подписываем через NCALayer (строка для подписи приходит прямо в result)
    const signature = await NCALayerSign(sign.result);
    // 3. Отправляем подпись на регистрацию талона
    if (signature) {
      const { data } = await TalonRegistrationApi.register({ notifyId, signature });
      if (data.status === 'SUCCESS') {
        Notice.success(i18next.t('talonRegistration_registerSuccess'));
        reload && reload();
      } else {
        handleError(data, i18next.t('talonRegistration_registerError'));
      }
    }
  } catch (error) {
    const errorCode = _.get(error, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(i18next.t('signTask_errorSignatureValidation'));
    } else {
      handleError(error, i18next.t('talonRegistration_registerError'));
    }
  } finally {
    dispatch({ type: REGISTERING, payload: null });
  }
};
